import { Component,EventEmitter, Input, Output, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-popup',
  templateUrl: './dialog-popup.component.html',
  styleUrls: ['./dialog-popup.component.scss']
})
export class DialogPopupComponent {

  @Input() heading: string = "";
  @Input() rejectLabel: string = "No"
  @Input() acceptLabel: string = "Yes"
  @Input() isConfirmation: boolean = false;
  @Input() showClose: boolean = true;


  @Output() close = new EventEmitter<boolean>();
  @Output() reject = new EventEmitter<boolean>();
  @Output() accept = new EventEmitter<boolean>();

  constructor() { }

  

  ngOnInit() {
    document.body.classList.add('modal-open'); 
  }

  ngOnDestroy() {
    document.body.classList.remove('modal-open'); 
  }

}
